import Link from 'next/link';
import { useBasePath } from '../../../../lib/use-base-path';
import { useTranslation } from '../../../../lib/i18n';
import { markNavFromDrawer } from '../../../../lib/drawer-nav';
import { useLeaveChatOnNavigate } from '../../../../lib/use-leave-chat';
import { useChatsGate } from '../../../../lib/chats-flag';

export function SeeAllChatsLink({ onClose }: { onClose?: () => void }) {
  const basePath = useBasePath();
  const { t } = useTranslation();
  const leaveChat = useLeaveChatOnNavigate();
  const { enabled } = useChatsGate();
  if (!enabled) return null;
  return <Link href="/chats" as={`${basePath}/chats`} className="orion-nav-item"
    style={{ display: 'block', padding: '8px 16px', marginBlockEnd: 8, borderRadius: 8,
      color: 'var(--ds-text-secondary)', textDecoration: 'none', fontSize: 14 }}
    onClick={() => { markNavFromDrawer(); leaveChat(); onClose?.(); }}>
    {t('chats.seeAll')}
  </Link>;
}
